import React, { useEffect, useState } from "react";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import { isLoggedIn, getAuthUser, clearBasicAuth, subscribeAuth } from "../api/auth";
import {DropdownMenu } from "@radix-ui/themes";
import { getCount, subscribe as subscribeCart } from "../cart/cart";
import { motion, AnimatePresence } from "framer-motion";
import Collapse from 'bootstrap/js/dist/collapse';
import "./Header.css"
import ContactModal from "./ContactModal";

function navLinkClass(args) {
    return args.isActive ? "nav-link active" : "nav-link";
}

function Header() {
    var navigate = useNavigate();
    var location = useLocation();
    var isHome = location.pathname === "/";

    var [logged, setLogged] = useState(isLoggedIn());
    var [user, setUser] = useState(getAuthUser());
    var [count, setCount] = useState(getCount()); // ⬅️
    var [contactOpen, setContactOpen] = useState(false);

    useEffect(function () {
        var unsubAuth = subscribeAuth(function () {
            setLogged(isLoggedIn());
            setUser(getAuthUser());
        });
        var unsubCart = subscribeCart(function () { // ⬅️
            setCount(getCount());
        });
        return function () { unsubAuth(); unsubCart(); };
    }, []);

    function handleLogout() {
        clearBasicAuth();
        navigate("/");
    }

    function handleNavClick() {
        var el = document.getElementById('mainNav');
        if (!el) { return; }
        // zavri len ak je práve otvorený (na mobile má class "show")
        if (el.classList.contains('show')) {
            var inst = Collapse.getInstance(el);
            if (!inst) { inst = new Collapse(el, { toggle: false }); }
            inst.hide();
        }
    }

    function toggleNav(e) {
        var el = document.getElementById('mainNav');
        if (!el) return;
        var inst = Collapse.getInstance(el);
        if (!inst) { inst = new Collapse(el, { toggle: false }); }
        inst.toggle();

        // voliteľné: zaktualizuj aria-expanded
        var isOpen = el.classList.contains('show');
        e.currentTarget.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function openModal() { setContactOpen(true); }
    function closeModal() { setContactOpen(false); }

    return (
        <div className="sticky-top">
            <nav className="navbar navbar-expand-lg bg-white border-bottom">
                <div className="container">
                    <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
                        <img
                            src="/LOGO.jpg"
                            alt="Logo MČ WOODDESIGN"
                            width="40"
                            height="40"
                            className="d-inline-block align-text-top"
                        />
                        <span className="d-flex flex-column lh-1">
                            <span className="fw-bolder">MČ WOODDESIGN</span>
                            <small className="text-muted">výroba drevených dekorácií</small>
                        </span>
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleNav}
                        aria-controls="mainNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="mainNav">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item"><NavLink to="/" end className={navLinkClass} onClick={handleNavClick}>domov</NavLink></li>
                            <li className="nav-item"><NavLink to="/o-nas" className={navLinkClass} onClick={handleNavClick}>o nás</NavLink></li>
                            <li className="nav-item"><NavLink to="/ponuka" className={navLinkClass} onClick={handleNavClick}>naša ponuka</NavLink></li>
                            <li className="nav-item"><NavLink to="/kontakt" className={navLinkClass} onClick={handleNavClick}>kontakt</NavLink></li>
                        </ul>

                        <div className="d-flex align-items-center gap-2 ms-lg-3">
                            {/* Košík */}
                            {/*}
                            <Link to="/kontakt" className="btn btn-brown rounded-pill position-relative" onClick={handleNavClick}>
                                <i className="bi bi-envelope"></i>
                                <span className="d-sm-inline">&nbsp;Napíšte nám</span>

                                <AnimatePresence>
                                    {count > 0 && (
                                        // OBAL: pozícia rohu (pravý horný roh vo vnútri tlačidla)
                                        <div className="position-absolute top-0 end-0 translate-middle-y z-1">
                                            <motion.span
                                                key={count}
                                                initial={{ opacity: 0, scale: 0 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.4,
                                                    scale: { type: "spring", visualDuration: 0.4, bounce: 0.7 },
                                                }}
                                                className="badge rounded-pill bg-danger"
                                                style={{ minWidth: 22, display: "inline-block", textAlign: "center" }}
                                            >
                                                {count}
                                            </motion.span>
                                        </div>
                                    )}
                                </AnimatePresence>
                            </Link>
                            */}

                            <button type="button" className="btn btn-brown rounded-pill px-4" onClick={openModal}>
                                <i className="bi bi-envelope"></i>
                                <span className="d-sm-inline">&nbsp;Napíšte nám</span>
                            </button>

                            {/* Prihlásenie / účet (ikonka) */}
                            {!logged ? (
                                <Link
                                    to="/login"
                                    className="btn btn-outline-secondary rounded-circle p-2"
                                    onClick={handleNavClick}
                                    title="Prihlásiť"
                                >
                                    <i className="bi bi-person"></i>
                                </Link>
                            ) : (
                                <DropdownMenu.Root>
                                    <DropdownMenu.Trigger>
                                        <button className="btn btn-outline-secondary rounded-circle p-2" title="Účet">
                                            <i className="bi bi-person-check"></i>
                                        </button>
                                    </DropdownMenu.Trigger>
                                    <DropdownMenu.Content align="end">
                                        <DropdownMenu.Item asChild>
                                            <Link to="/admin/produkty">Admin</Link>
                                        </DropdownMenu.Item>
                                        <DropdownMenu.Item asChild>
                                            <Link to="/produkt/novy">Pridať produkt</Link>
                                        </DropdownMenu.Item>
                                        <DropdownMenu.Separator />
                                        <DropdownMenu.Item color="red" onClick={handleLogout}>
                                            Odhlásiť
                                        </DropdownMenu.Item>
                                    </DropdownMenu.Content>
                                </DropdownMenu.Root>
                            )}
                        </div>
                    </div>
                </div>
            </nav>

            <ContactModal show={contactOpen} onHide={closeModal} product={null} slug={null}/>

            {/* drevená linka všade okrem úvodnej stránky */}
            {!isHome && <div className="wood-line"></div>}
        </div>
    );
}

export default Header;
